import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AuthenticationService } from '../../../services/authentication/authentication.service';

@Component({
  selector: 'ftl-quote-logout',
  templateUrl: './logout.component.html',
  styleUrls: ['./logout.component.scss']
})
export class LogoutComponent implements OnInit {

  constructor(private authenticationService: AuthenticationService) { }

  show = false;

  ngOnInit() {
    if (this.authenticationService.isLoggedIn()) {
      this.authenticationService.logout();
    }
  }
}
